export const formTypes = [
     {name: 'Text', value: 'text'},
     {name: 'Number', value: 'number'},
         {name: 'List', value: 'list'},
        //  {name: 'Scan', value: 'scan'},
         {name: 'Photo', value: 'photo'},
         {name: 'Zoom', value: 'zoom'}
];